// constants.js

export const RESIDENCE_OPTIONS = [
    { label: "Student Housing", value: "Student Housing" },
    { label: "Canterbury Greens", value: "Canterbury Greens" },
    { label: "St. Joe's", value: "St. Joe's" },
    { label: "Others", value: "Others" }
];

export const PRICE_OPTIONS = [
    { label: "0 - 10", value: "0-10" },
    { label: "10 - 20", value: "10-20" },
    { label: "20 - 40", value: "20-40" },
    { label: "40 - 50", value: "40-50" },
    { label: "50+", value: "50+" }
];

export const CONDITION_OPTIONS = [
    { label: "Flawless", value: "flawless" },
    { label: "Good", value: "good" },
    { label: "Average", value: "average" },
    { label: "Poor", value: "poor" }
];

export const AGE_OPTIONS = [
    { label: "Brand New", value: "brand-new" },
    { label: "0-1 month", value: "0-1month" },
    { label: "1-3 months", value: "1-3months" },
    { label: "1-6 months", value: "1-6months" },
    { label: "6-12 months", value: "6-12months" },
    { label: "1 year+", value: "1year" }
];

export const CATEGORY_OPTIONS = [
    { label: "Kitchen", value: "kitchen" },
    { label: "Appliances", value: "appliances" },
    { label: "Electronics", value: "electronics" },
    { label: "Furniture", value: "furniture" }
];
